import { get, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { ICONS } from './utils/constants';
import { navigateOnEnterOrSpace } from '../../../utils/Browser';
import { isHexColorCode } from '../../../utils/colors';

const Icon = ({
  ariaControls = null,
  ariaExpanded = null,
  ariaLabel = undefined,
  canReceiveFocus = true,
  className = '',
  // TO-DO: Confirm color based on new color pallette with UI/UX team
  color = 'medium-grey',
  disabled = false,
  icons = {},
  icon = '',
  id = '',
  onClick = null,
  size = 16,
  style = {},
  direction = 'up', // Available options: up, down, left, right
}) => {
  const isHexColor = isHexColorCode(color);
  const styles = isEmpty(style)
    ? {
        svg: {
          display: 'inline-block',
          verticalAlign: 'middle',
          fill: isHexColor ? color : '',
        },
      }
    : style;

  const svgClass = isHexColor ? className : `${className} fill-current text-${color}`;
  const viewBox = get(icons, 'icon.viewBox', null) || get(ICONS, icon, {}).viewBox;
  const iconImage = get(icons, 'icon.markup', null) || get(ICONS, icon, {}).markup;

  if (isEmpty(viewBox) || isEmpty(iconImage)) {
    return <p>Icon viewBox or markup does not exist!</p>;
  }

  const directionClass = () =>{
    switch(direction){
      case 'up':
        return 'transform rotate-0';
      case 'down':
        return 'transform rotate-180';
      case 'left':
        return 'transform -rotate-90';
      case 'right':
        return 'transform rotate-90';
      default:
        return 'transform rotate-0';
    }
  }

  if (onClick && !disabled) {
    return (
      <a
        role="button"
        aria-controls={ariaControls}
        aria-expanded={ariaExpanded}
        aria-label={ariaLabel}
        onClick={onClick}
        tabIndex={canReceiveFocus ? 0 : -1}
        onKeyDown={navigateOnEnterOrSpace(onClick)}
        className='flex items-center justify-center'
      >
        <svg
          id={id}
          className={`${svgClass} ${directionClass()}`}
          style={styles.svg}
          width={`${size}px`}
          height={`${size}px`}
          viewBox={viewBox}
          data-testid={icon}
        >
          {iconImage}
        </svg>
      </a>
    );
  }

  return (
    <svg
      id={id}
      className={`${svgClass} ${directionClass()}`}
      style={styles.svg}
      width={`${size}px`}
      height={`${size}px`}
      viewBox={viewBox}
      aria-label={ariaLabel}
      data-testid={icon}
      role="img"
    >
      {iconImage}
    </svg>
  );  
};

Icon.propTypes = {
  ariaControls: PropTypes.string,
  ariaExpanded: PropTypes.bool,
  ariaLabel: PropTypes.string,
  canReceiveFocus: PropTypes.bool,
  className: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.oneOf(
    Object.keys(ICONS)
  ).isRequired,
  icons: PropTypes.object,
  id: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.number,
  style: PropTypes.object,
  direction: PropTypes.oneOf(['up', 'down', 'left', 'right']),
};

export default Icon;
